export const LABEL_FIELD_GROUP = 'CD2.ClientBrandingConfiguration';
export const LABEL_FIELD_REVIEWAPPOINTMENTDETAILS = `${LABEL_FIELD_GROUP}.ReviewAppointmentDetailsLabel`;
export const LABEL_FIELD_APPOINTMENTSUCCESSLABEL = `${LABEL_FIELD_GROUP}.AppointmentSuccessLabel`;
export const LABEL_FIELD_ADDITIONALINFORMATIONLABEL = `${LABEL_FIELD_GROUP}.AdditionalInformationLabel`;
export const LABEL_FIELD_SCHEDULEFOLLOWUPLABEL = `${LABEL_FIELD_GROUP}.ScheduleFollowUpLabel`;
export const LABEL_FIELD_PROVIDERDETAILSLABEL = `${LABEL_FIELD_GROUP}.ProviderDetailsLabel`;
export const LABEL_FIELD_AVAILABILITYSEARCHHEADER = `${LABEL_FIELD_GROUP}.AvailabilitySearchHeader`;
